import { useCallback, useMemo, useState } from 'react';

export default function useModalState<T extends string, TMeta = unknown>({
  defaultValue,
}: {
  defaultValue?: T | undefined;
} = {}) {
  const [modalState, setModalState] = useState<{
    selected: T | undefined;
    meta?: TMeta;
  }>({ selected: defaultValue });
  const updateModal = useCallback((selected?: T, meta?: TMeta) => {
    setModalState({
      selected,
      meta,
    });
  }, []);

  const handlers = useMemo(
    () => ({
      close: () => updateModal(undefined),
      open: (key: T, metaData?: TMeta) => updateModal(key, metaData),
    }),
    [updateModal],
  );

  return [modalState.selected, handlers, modalState.meta] as const;
}
